import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { RbacAccessDenied } from '~/components/routes/administration/roles/access-denied'
import { RoleDetailView } from '~/components/routes/administration/roles/role-detail-view'
import { useRights } from '~/utils/hooks'

export const Route = createFileRoute('/_authenticated/administration/roles/$roleId/')({
  component: AdministrationRoleDetailPage,
  params: {
    parse: z.object({ roleId: z.coerce.number() }).parse,
  },
})

function AdministrationRoleDetailPage() {
  const { roleId } = Route.useParams()
  const isSuperAdmin = useRights(['SUPER_ADMIN'])

  if (!isSuperAdmin) {
    return <RbacAccessDenied />
  }

  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer className="space-y-4">
        <RoleDetailView roleId={roleId} />
      </AppContainer>
    </>
  )
}
